module.exports = __webpack_public_path__ + "static/media/register-1920w.b2fa716b.jpg";